<template>
  <div>
    <h3 v-if="readonly">{{value}}</h3>
        <!-- <h3 v-if="readonly">{{value}} ( {{ikey}} )</h3> -->
    <input class="numberInput" v-else type="number" :readonly="readonly" :value="value" @input="change($event)" />
  </div>
</template>

<script>
export default {
  props: ["readonly", "emitter", "ikey", "getData", "putData"],
  data() {
    return {
      value: 0
    };
  },
  methods: {
    change(e) {
      this.value = +e.target.value;
    //  console.log("number changed " + JSON.stringify(e) + "value" + this.value);
      this.update();
    },
    update() {
      if (this.ikey) {
        this.putData(this.ikey, this.value);
    //    console.log("key=" + this.ikey + " value=" + this.value);
      }
      this.emitter.trigger("process");
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.value = this.getData(this.ikey);
  //    console.log("key=" + this.ikey + " value=" + this.value);
    }
  }
};
</script>

<style scoped>
h3 {
font-weight: bolder;
    font-family: "Comic Sans MS", cursive, sans-serif;
    text-align: center;
    font-size: xx-large;
}
  input.numberInput {
    /* background-color: white; */
    font-size: x-large;
    box-shadow: -5px -3px 20px 0px royalblue;

}
</style>
